import Lottie from 'lottie-react';
import React from 'react';
import progressAnim from '../../assets/lottie-animation/Progress.json';
import './LoadingPage.scss';

const LoadingPage = () => {
	return (
		<div className='LoadingPage'>
			<Lottie className='LoadingPage__loader' animationData={progressAnim} />
		</div>
	);
};

export default LoadingPage;
